import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { logout } from "../../store/auth/authSlice";

export const ButtonCloseSesion = ({ size }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation('global');

    const onClose = () => {
        try {           
            window.flutter_inappwebview.callHandler('notifications')
            dispatch(logout())
        } catch (error) {
            dispatch(logout())
        }
    }
    return (
        <Button color='info' onClick={onClose}>
            <Stack width='100%' direction='row' gap={1} justifyContent='center'>
                <ExitToAppIcon />
                {
                    size === 'big' &&
                    <Typography >{t('drawer.exit')}</Typography>
                }
            </Stack>
        </Button>
    )
}
